import { render, staticRenderFns } from "./SegmentTranscript.vue?vue&type=template&id=07c6a8fe&scoped=true&"
import script from "./SegmentTranscript.vue?vue&type=script&lang=ts&"
export * from "./SegmentTranscript.vue?vue&type=script&lang=ts&"
import style0 from "./SegmentTranscript.vue?vue&type=style&index=0&id=07c6a8fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6a8fe",
  null
  
)

export default component.exports